import { isDisplayableLrrContentStatus } from '@/agent-v2/references/lrr-content-status'
import type { AgentV2Reference } from '@/agent-v2/store/schemas'

/**
 * The content status for a reference; only LRR references carry one.
 *
 * Kept out of `lrr-content-status.ts` so that module stays free of the AgentV2Reference
 * type: the split-pane and standalone viewers import the status vocabulary from there and
 * never call these helpers, so they should not carry agent-v2's reference shape.
 */
export function getAgentV2ReferenceLrrContentStatus(reference: AgentV2Reference): string | null {
  return reference.source_type === 'lrr' ? reference.content_status ?? null : null
}

/** True when any reference in the conversation is flagged, which is what the banner keys on. */
export function hasFlaggedLrrReference(references: AgentV2Reference[]): boolean {
  return references.some((reference) => isDisplayableLrrContentStatus(getAgentV2ReferenceLrrContentStatus(reference)))
}
